"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ui = require("@unite-us/ui");
var _lodash = require("lodash");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ServiceTypesCheckbox = function ServiceTypesCheckbox(_ref) {
  var onChange = _ref.onChange,
    id = _ref.id,
    item = _ref.item,
    labelKey = _ref.labelKey,
    valueKey = _ref.valueKey,
    value = _ref.value,
    level = _ref.level,
    autoSelectParent = _ref.autoSelectParent,
    autoSelectChildren = _ref.autoSelectChildren,
    allOptions = _ref.allOptions;
  var handleChange = function handleChange() {
    onChange(item, level);
  };
  var containerClass = function containerClass() {
    return (0, _classnames["default"])({
      'service-types-checkbox': true,
      'service-types-checkbox__child': level > 0
    });
  };
  var checkboxClass = function checkboxClass() {
    return (0, _classnames["default"])({
      'service-types-checkbox__parent': level === 0,
      'service-types-checkbox__child': level > 0
    });
  };
  var itemChildren = (0, _lodash.get)(item, 'children', []);
  var disabled = (0, _utils.isAutoAdded)({
    opt: item,
    value: value,
    allOptions: allOptions,
    valueKey: valueKey,
    level: level,
    autoSelectParent: autoSelectParent,
    autoSelectChildren: autoSelectChildren
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClass()
  }, /*#__PURE__*/_react["default"].createElement(_ui.CheckBoxField, {
    id: id,
    className: checkboxClass(),
    onChange: handleChange,
    label: (0, _lodash.get)(item, labelKey, ''),
    checked: (0, _utils.isSelected)(item, value, valueKey),
    disabled: disabled || item.sensitive,
    showError: false,
    showHint: false
  }), itemChildren.map(function (child, i) {
    var checkBoxId = "".concat(id, "-").concat(i);
    return /*#__PURE__*/_react["default"].createElement(ServiceTypesCheckbox, {
      allOptions: allOptions,
      autoSelectChildren: autoSelectChildren,
      autoSelectParent: autoSelectParent,
      id: checkBoxId,
      item: child,
      key: "child-".concat(checkBoxId),
      labelKey: labelKey,
      level: level + 1,
      onChange: onChange,
      value: value,
      valueKey: valueKey,
      disabled: disabled || child.sensitive
    });
  }));
};
ServiceTypesCheckbox.propTypes = {
  allOptions: _propTypes["default"].array.isRequired,
  autoSelectChildren: _propTypes["default"].bool.isRequired,
  autoSelectParent: _propTypes["default"].bool.isRequired,
  id: _propTypes["default"].string.isRequired,
  item: _propTypes["default"].object.isRequired,
  labelKey: _propTypes["default"].string.isRequired,
  level: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].any,
  valueKey: _propTypes["default"].string.isRequired
};
ServiceTypesCheckbox.defaultProps = {
  level: 0,
  value: false
};
var _default = exports["default"] = ServiceTypesCheckbox;